import { baseLookup } from './lookupClient'
export interface CountryOption {
  value: string
  label: string
}

const getCountries = () => baseLookup('countries')

export default getCountries
